module.exports = __webpack_public_path__ + "static/media/web2004.b0a0b038.jpg";